class Message {
    //消息ID
    id = "";
    //消息类型 1: 普通包文 ,2:消息确认帧
    msgType = 1;
    //消息类型
    code = "";
    //认证通行证
    token = "";
    //消息数据
    data = "";
    //确认帧ID
    askId = "";
    //需要对方确认应答
    isAsk = false;
    //是否回复数据
    isReply = false;

    rests = "";


    /**
     *
     * @param {Object} data 消息数据
     * @param {Object} MsgType 消息类型 1: 普通包文 ,2:消息确认帧
     * @param {Object} code 消息类型[]
     * @param {Object} ask 需要对方确认应答
     * @param {Object} isReply 是否应答数据
     */
    constructor(data = '',MsgType = 1,code = '',ask = false,isReply = false) {
        this.data = data;
        this.msgType = MsgType;
        this.code = code;
        this.isAsk = ask;
        this.isReply = isReply;
    }


    getJson() {
        return JSON.stringify(this.getData());
    }

    getData(){

        return {
            data	: this.data,
            msgType : this.msgType,
            code	: this.code,
            isAsk	: this.isAsk,
            isReply	: this.isReply,
            id		: this.id,
            token	: this.token,
            rests	: this.rests,
            askId	: this.askId
        };
    }
}

export default Message
